export const formatName = (
  firstName: string | null,
  lastName: string | null
): string => {
  if (!firstName && !lastName) {
    return 'N/A';
  }
  return `${firstName ?? ''} ${lastName ?? ''}`.trim();
};
